import React from 'react'

const Heart = () => {
    return (
        <svg width="36" height="36" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.91235 24.728L20.2735 36.34C20.6993 36.74 20.9122 36.94 21.1632 36.9893C21.2763 37.0115 21.3926 37.0115 21.5056 36.9893C21.7566 36.94 21.9695 36.74 22.3953 36.34L34.7565 24.728C38.2344 21.4609 38.6568 16.0845 35.7317 12.3144L35.1817 11.6055C31.6824 7.09532 24.6585 7.85171 22.1997 13.0035C21.8524 13.7312 20.8165 13.7312 20.4692 13.0035C18.0104 7.85171 10.9865 7.09532 7.4872 11.6055L6.93719 12.3144C4.01209 16.0845 4.43443 21.4609 7.91235 24.728Z" stroke="#33363F" stroke-width="3.55583" />
        </svg>

    )
}

export default Heart